import { ShopComponent } from './shop'
import { SidebarComponent } from '../../components/sidebar/sidebar'
import { BaseComponent } from '../../components/base-component'
import { isEnterKey } from '../../utils/key'
import { debounce } from '../../utils/debounce'
import { $el, $list, $elParent } from 'src/scripts/utils/utils'

const LABEL_SELECTOR = '[data-sort-list-label]'
const SHOP_SELECTOR = 'shop-component'
const SIDEBAR_SELECTOR = 'sidebar-component'
const FORM_SELECTOR = 'form'
const INPUT_SELECTOR = 'input'

export class SortList extends BaseComponent {
  mountComponent(): void {
    const labels = $list(LABEL_SELECTOR, this)

    labels.forEach(label => {
      this.addListener(label, 'keydown', this.handleLabelKeyDown)
    })
    this.addListener(this, 'input', this.handleFormInput)
  }

  handleFormInput = debounce((event: SubmitEvent): void => {
    event.preventDefault()

    const shop: ShopComponent = $el(SHOP_SELECTOR)
    const sidebar: SidebarComponent = $elParent(SIDEBAR_SELECTOR, this)
    const input = event.target as HTMLInputElement

    if (sidebar) {
      sidebar.hide()
    }

    if (shop && input) {
      const sortQuery = this.getSortQuery(input)

      let searchParams = `${window.location.search
        .replace(shop.sortQuery, '')
        .replace('?', '')}&${sortQuery}`

      if (shop.dataset.baseParams) {
        searchParams = searchParams.replace(shop.dataset.baseParams, '')
      }

      shop.sortQuery = sortQuery
      shop.updateBySearchParams(searchParams)
    }
  }, 250)

  handleLabelKeyDown = (event: KeyboardEvent): void => {
    if (isEnterKey(event)) {
      event.preventDefault()

      const input: HTMLInputElement = $el(INPUT_SELECTOR, event.target)

      if (input) {
        input.dispatchEvent(new MouseEvent('click', { button: 0, which: 1 }))
      }
    }
  }

  getSortQuery(input: HTMLInputElement): string {
    const form: HTMLFormElement = $elParent(FORM_SELECTOR, input)

    if (!form) {
      return ''
    }

    return new URLSearchParams(new FormData(form) as any).toString()
  }
}
